import { cn } from "@/lib/utils";
import type { Signal } from "@/features/decodificar/express/types";
import { TYPE_ACCENT } from "@/features/decodificar/content";
import type { EnneagramTypeId } from "@/types/supabase";

interface SignalChipsProps {
  signal: Signal;
  selected: EnneagramTypeId | undefined;
  onSelect: (type: EnneagramTypeId) => void;
}

export function SignalChips({ signal, selected, onSelect }: SignalChipsProps) {
  return (
    <fieldset className="space-y-3">
      <legend className="space-y-1">
        <span className="block text-sm font-semibold text-foreground">
          {signal.prompt}
        </span>
        <span className="block text-xs text-muted-foreground">
          {signal.helper}
        </span>
      </legend>
      <div className="flex flex-wrap gap-2">
        {signal.options.map((opt) => {
          const isSelected = selected === opt.type;
          const accent = TYPE_ACCENT[opt.type];
          return (
            <button
              key={opt.type}
              type="button"
              onClick={() => onSelect(opt.type)}
              aria-pressed={isSelected}
              className={cn(
                "rounded-full border px-3 py-2 text-left text-xs leading-snug transition-all",
                "min-h-[44px] flex items-center gap-2",
                isSelected
                  ? "border-transparent text-white shadow-sm"
                  : "border-border bg-card text-foreground hover:border-foreground/30",
              )}
              style={
                isSelected
                  ? { backgroundColor: accent, borderColor: accent }
                  : undefined
              }
            >
              <span
                aria-hidden
                className="inline-block h-2 w-2 shrink-0 rounded-full"
                style={{ backgroundColor: accent }}
              />
              <span>{opt.label}</span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
